import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TOP_PERFORMING_GOAL_SUCCESS,
  FETCH_LEAST_PERFORMING_GOAL_SUCCESS,
  FETCH_GOALS_TO_WATCH_SUCCESS,
  FETCH_GOALS_SUCCESS,
  FETCH_GOALS_BY_DATE_SUCCESS
} from "./goalsSummarySagas";

export const initialState = {
  currentUser: {},
  prevPageFilters: { prevDate: null },
  initRequest: false,
  topPerformingGoal: {},
  worstPerformingGoal: {},
  goalsToWatch: [],
  goalsList: [],
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_TOP_PERFORMING_GOAL_SUCCESS]: (state, action) => ({
      ...state,
      topPerformingGoal: action.payload.goals[0] || state.topPerformingGoal
    }),
    [FETCH_LEAST_PERFORMING_GOAL_SUCCESS]: (state, action) => ({
      ...state,
      worstPerformingGoal: action.payload.goals[0] || state.worstPerformingGoal
    }),
    [FETCH_GOALS_TO_WATCH_SUCCESS]: (state, action) => ({
      ...state,
      goalsToWatch: action.payload.goals || state.goalsToWatch
    }),
    [FETCH_GOALS_SUCCESS]: (state, action) => ({
      ...state,
      goalsList: action.payload.goals || state.goalsList
    }),
    [FETCH_GOALS_BY_DATE_SUCCESS]: (state, action) => ({
      ...state,
      goalsList: action.payload.goals || state.goalsList,
      isLoading: false
    })
  },
  initialState
);
